export const fileType = {
	image: {
		title: 'تصویر',
		accept: 'image/*'
	},
	video: {
		title: 'ویدیو',
		accept: 'video/*'
	},
	sound: {
		title: 'صوت',
		accept: 'audio/*'
	},
	text: {
		title: 'متن'
	},
	link: {
		title: 'لینک'
	}
};
